import React from 'react';
import Alcohol from './Alcohol';
import Marijuana from './Marijuana';
import Nicotine from './Nicotine';
import Vaping from './Vaping';
import ReadMore from './ReadMore';
import './styles.scss';

const Health = () => {
  return (
    <div className="content">
      <section className="anchor-teen section" id="Health Effects">
        <div className="has-text-centered">
          <h2 className="is-size-2">
            Health Effects of The Most Commonly Used Substances by Teens and
            Young Adults
          </h2>
        </div>
      </section>
      <Alcohol />
      <Marijuana />
      <Nicotine />
      <Vaping />
      <ReadMore />
    </div>
  );
};

export default Health;
